import React, { useEffect, useState } from "react";
import CargaDinamic from "../../pages/Crear-grafico-dinamic/Crear-grafico-dinamic";
import axios from "axios";
import { API_URL_LOCALE_BASE } from "../../configuration/config";
import Swal from "sweetalert2";
import Loading from "../shared/Loading/Loading";

const Toast = Swal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
  timerProgressBar: true,
  didOpen: (toast) => {
    toast.addEventListener("mouseenter", Swal.stopTimer);
    toast.addEventListener("mouseleave", Swal.resumeTimer);
  },
});

const MainCP = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [selectOptions, setSelectOptions] = useState<object[]>([]);

  useEffect(() => {
    setIsLoading(true);
    axios
      .post(API_URL_LOCALE_BASE + "get-grafico-dinamicos",{})
      .then(async ({ data }) => {
        // console.log(data);
        if (data.status) {
          // console.log(data.response);
          setSelectOptions(data.data);
        } else {
          Swal.fire("Algo salio mal :C", "Error al obtener data", "error");
        }
        // console.log("Acás....")
        setIsLoading(false);
      });
  }, []);
  return (
    <>
      {isLoading ? <Loading /> : null}
      <CargaDinamic options={selectOptions} />
    </>
  );
};

export default MainCP;
